import React from 'react';
import {Button} from "antd";
import {RightOutlined} from "@ant-design/icons";
import {DIR_RTL} from "../../../../../constants/ThemeConstant";
import {useSelector} from "react-redux";
import {APP_PREFIX_PATH} from "../../../../../configs/AppConfig";
import SliderProduct from "./SliderProduct";
import {Link, useHistory} from "react-router-dom";

// import MenuProduct from "./MenuProduct";

function MenuCategory({category}) {
    const history = useHistory();
    const {direction, locale} = useSelector(state => state.theme)
    return (
        <>
            <div className="element d-flex my-1 py-2 justify-content-between align-items-center border-bottom">
                <h3 className='m-0'>{locale==='en' ? category?.nameEng : category?.nameAr}</h3>
                <Button 
                    onClick={()=>history.push(`${APP_PREFIX_PATH}/categories/${category?.id}?nameEng=${category?.nameEng}&nameAr=${category?.nameAr}`)} 
                    style={{color: '#000'}} 
                    type="link"
                >
                    Show More
                    <RightOutlined rotate={direction === DIR_RTL ? 180 : 0}/>
                </Button>
            </div>
            <div className="d-flex mt-4 overflow-auto">
                {category?.products?.map(product => <Link 
                            to={APP_PREFIX_PATH + '/products/' + product.id}
                            key={product.id}
                        >
                    <SliderProduct product={product} locale={locale}/>
                </Link>)}
            </div>
        </>
    );
}

export default MenuCategory;